import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  return <section className="py-16 md:py-24 bg-[#FFF8ED] px-4" data-id="element-223">
      <div className="max-w-4xl mx-auto" data-id="element-224">
        <FadeInSection data-id="element-225">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-226">
            {/* Es para ti */}
            <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-green-500" data-id="element-227">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-228">
                <Check className="w-8 h-8 text-green-500 mr-2" data-id="element-229" />
                Este método ES PARA TI si...
              </h3>
              <ul className="space-y-4 text-lg text-gray-700" data-id="element-230">
                <li className="flex items-start" data-id="element-231">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-232">✓</span> Estás
                  cansado de dietas restrictivas que nunca logras mantener.
                </li>
                <li className="flex items-start" data-id="element-233">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-234">✓</span>{' '}
                  Quieres ver resultados reales sin renunciar a tus comidas
                  favoritas.
                </li>
                <li className="flex items-start" data-id="element-235">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-236">✓</span>{' '}
                  Sientes que tu energía se desploma a mitad del día.
                </li>
                <li className="flex items-start" data-id="element-237">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-238">✓</span> Te
                  preocupan tus niveles de glucosa y quieres tomar el control.
                </li>
                <li className="flex items-start" data-id="element-239">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-240">✓</span>{' '}
                  Buscas un método simple y lógico que puedas empezar hoy mismo.
                </li>
                <li className="flex items-start" data-id="element-241">
                  <span className="text-green-500 mr-2 font-bold" data-id="element-242">✓</span>{' '}
                  Tienes familia y necesitas algo práctico que todos puedan
                  aplicar.
                </li>
              </ul>
            </div>

            {/* NO es para ti */}
            <div className="bg-white p-8 rounded-2xl shadow-md border-t-4 border-red-500" data-id="element-243">
              <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-244">
                <X className="w-8 h-8 text-red-500 mr-2" data-id="element-245" />
                Este método NO ES para ti si...
              </h3>
              <ul className="space-y-4 text-lg text-gray-700" data-id="element-246">
                <li className="flex items-start" data-id="element-247">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-248">✗</span> Buscas
                  una "pastilla mágica" que solucione todo sin ningún esfuerzo.
                </li>
                <li className="flex items-start" data-id="element-249">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-250">✗</span> No
                  estás dispuesto a hacer pequeños cambios en tu rutina diaria.
                </li>
                <li className="flex items-start" data-id="element-251">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-252">✗</span> Esperas
                  perder 10 kilos de la noche a la mañana de forma irreal.
                </li>
                <li className="flex items-start" data-id="element-253">
                  <span className="text-red-500 mr-2 font-bold" data-id="element-254">✗</span>{' '}
                  Necesitas tratamiento médico urgente (por favor, consulta a tu
                  doctor).
                </li>
              </ul>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>;
}